module.exports = __webpack_public_path__ + "img/olusola.62ce1842.jpeg";